import React from 'react';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { Tooltip } from '../tooltip';

interface ICalendarToolbarButtonProps {
  icon: IconDefinition;
  toolbarText: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function CalendarToolbarButton(props: ICalendarToolbarButtonProps) {
  const { icon, onClick, toolbarText } = props;

  return (
    <Tooltip title={toolbarText}>
      <IconButton onClick={onClick} sx={{ pt: 0.3, pb: 0.3, borderRadius: 1 }}>
        <FontAwesomeIcon icon={icon} size="sm" />
      </IconButton>
    </Tooltip>
  );
}
